import { render, staticRenderFns } from "./EditRequest.vue?vue&type=template&id=0f235aca&scoped=true&"
import script from "./EditRequest.vue?vue&type=script&lang=js&"
export * from "./EditRequest.vue?vue&type=script&lang=js&"
import style0 from "../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./EditRequest.vue?vue&type=style&index=1&id=0f235aca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f235aca",
  null
  
)

export default component.exports